// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Blob = require("../../bindings/Blob.bs.js");
let Axios = require("bs-axios/src/axios.bs.js");
let Axios$1 = require("axios");
let Sentry = require("../../Sentry.bs.js");
let ImageUtils = require("../../common/imageUtils/ImageUtils.bs.js");
let ReactUpdate = require("rescript-react-update/src/ReactUpdate.bs.js");
let Primitive_int = require("@rescript/runtime/lib/js/Primitive_int.js");
let ReasonPromise = require("../../ReasonPromise.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let AvatarUploadProvider_RequestAvatarUploadV5Mutation_graphql = require("../../../__generated__/AvatarUploadProvider_RequestAvatarUploadV5Mutation_graphql.bs.js");

let convertVariables = AvatarUploadProvider_RequestAvatarUploadV5Mutation_graphql.Internal.convertVariables;

let convertResponse = AvatarUploadProvider_RequestAvatarUploadV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = AvatarUploadProvider_RequestAvatarUploadV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, AvatarUploadProvider_RequestAvatarUploadV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, AvatarUploadProvider_RequestAvatarUploadV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let RequestAvatarUploadV5Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let initialState = {
  progress: 0,
  uploading: false,
  fileName: undefined,
  fileSize: undefined,
  contentType: undefined,
  url: undefined,
  error: undefined,
  resolve: undefined,
  blob: undefined,
  uploadInfo: undefined
};

function useUpload() {
  let match = use();
  let requestUploadMutate = match[0];
  let match$1 = ReactUpdate.useReducer((state, action) => {
    if (typeof action !== "object") {
      return {
        TAG: "UpdateWithSideEffects",
        _0: {
          progress: state.progress,
          uploading: false,
          fileName: state.fileName,
          fileSize: state.fileSize,
          contentType: state.contentType,
          url: state.url,
          error: state.error,
          resolve: state.resolve,
          blob: state.blob,
          uploadInfo: state.uploadInfo
        },
        _1: param => {
          let state = param.state;
          let x = state.uploadInfo;
          if (x !== undefined) {
            Stdlib_Option.forEach(state.resolve, r => r({
              TAG: "Ok",
              _0: x
            }));
          } else {
            param.send({
              TAG: "SetError",
              _0: "No uploadInfo in respose"
            });
          }
        }
      };
    }
    switch (action.TAG) {
      case "InitiateUpload" :
        let dataUrl = action._0;
        return {
          TAG: "UpdateWithSideEffects",
          _0: {
            progress: state.progress,
            uploading: state.uploading,
            fileName: state.fileName,
            fileSize: state.fileSize,
            contentType: state.contentType,
            url: state.url,
            error: state.error,
            resolve: action._1,
            blob: state.blob,
            uploadInfo: state.uploadInfo
          },
          _1: param => {
            let send = param.send;
            Blob.from_url(dataUrl).then(blob => Promise.resolve(send({
              TAG: "ReceivedBlob",
              _0: blob
            })));
          }
        };
      case "ReceivedBlob" :
        let blob = action._0;
        let fileName = new Date().getMilliseconds().toString();
        let fileSize = blob.size;
        let contentType = blob.type;
        return {
          TAG: "UpdateWithSideEffects",
          _0: {
            progress: state.progress,
            uploading: state.uploading,
            fileName: fileName,
            fileSize: fileSize,
            contentType: contentType,
            url: state.url,
            error: state.error,
            resolve: state.resolve,
            blob: Primitive_option.some(blob),
            uploadInfo: state.uploadInfo
          },
          _1: param => {
            let send = param.send;
            requestUploadMutate({
              input: {
                contentType: contentType,
                fileName: fileName,
                fileSize: fileSize
              }
            }, undefined, undefined, undefined, (param, param$1) => {
              let requestAvatarUploadV5 = param.requestAvatarUploadV5;
              if (requestAvatarUploadV5 === undefined) {
                return send({
                  TAG: "SetError",
                  _0: "Error sending mutation"
                });
              }
              if (requestAvatarUploadV5.__typename !== "UploadV5") {
                return send({
                  TAG: "SetError",
                  _0: "Error sending mutation"
                });
              }
              let contentType = requestAvatarUploadV5.contentType;
              if (contentType === undefined) {
                return send({
                  TAG: "SetError",
                  _0: "Error sending mutation"
                });
              }
              let fileName = requestAvatarUploadV5.fileName;
              if (fileName === undefined) {
                return send({
                  TAG: "SetError",
                  _0: "Error sending mutation"
                });
              }
              let id = requestAvatarUploadV5.id;
              if (id === undefined) {
                return send({
                  TAG: "SetError",
                  _0: "Error sending mutation"
                });
              }
              let key = requestAvatarUploadV5.key;
              if (key === undefined) {
                return send({
                  TAG: "SetError",
                  _0: "Error sending mutation"
                });
              }
              let url = requestAvatarUploadV5.url;
              if (url !== undefined) {
                return send({
                  TAG: "ReceivedUploadInfo",
                  _0: {
                    contentType: contentType,
                    fileName: fileName,
                    id: id,
                    key: key,
                    url: url
                  }
                });
              } else {
                return send({
                  TAG: "SetError",
                  _0: "Error sending mutation"
                });
              }
            }, e => {
              Sentry.captureException(new Error(e.message), "AvatarUploadProvider.res", 133, {
                exn: e
              }, undefined);
              send({
                TAG: "SetError",
                _0: "Error sending mutation"
              });
            }, undefined);
          }
        };
      case "ReceivedUploadInfo" :
        let avatarUploadInfo = action._0;
        let blob$1 = state.blob;
        if (blob$1 === undefined) {
          return "NoUpdate";
        }
        let blob$2 = Primitive_option.valFromOption(blob$1);
        return {
          TAG: "UpdateWithSideEffects",
          _0: {
            progress: state.progress,
            uploading: state.uploading,
            fileName: state.fileName,
            fileSize: state.fileSize,
            contentType: state.contentType,
            url: state.url,
            error: state.error,
            resolve: state.resolve,
            blob: state.blob,
            uploadInfo: avatarUploadInfo
          },
          _1: param => {
            let send = param.send;
            let config = {
              headers: Axios.Headers.fromObj({
                "Content-Type": avatarUploadInfo.contentType
              }),
              onUploadProgress: evt => {
                if (evt.lengthComputable) {
                  send({
                    TAG: "SetProgress",
                    _0: Primitive_int.div(evt.loaded, evt.total)
                  });
                  return;
                }
              }
            };
            ReasonPromise.get(ReasonPromise.Js.toResult(ReasonPromise.Js.fromBsPromise(Axios$1.put(avatarUploadInfo.url, blob$2, config))), res => {
              if (res.TAG === "Ok") {
                return send("FinishedUpload");
              } else {
                return send({
                  TAG: "SetError",
                  _0: "Error uploading"
                });
              }
            });
          }
        };
      case "SetProgress" :
        return {
          TAG: "Update",
          _0: {
            progress: action._0,
            uploading: state.uploading,
            fileName: state.fileName,
            fileSize: state.fileSize,
            contentType: state.contentType,
            url: state.url,
            error: state.error,
            resolve: state.resolve,
            blob: state.blob,
            uploadInfo: state.uploadInfo
          }
        };
      case "SetError" :
        let error = action._0;
        return {
          TAG: "UpdateWithSideEffects",
          _0: {
            progress: state.progress,
            uploading: false,
            fileName: state.fileName,
            fileSize: state.fileSize,
            contentType: state.contentType,
            url: state.url,
            error: error,
            resolve: state.resolve,
            blob: state.blob,
            uploadInfo: state.uploadInfo
          },
          _1: param => {
            let resolve = param.state.resolve;
            if (resolve !== undefined) {
              resolve({
                TAG: "Error",
                _0: error
              });
            }
          }
        };
    }
  }, initialState);
  let send = match$1[1];
  return dataUrl => {
    let match = ReasonPromise.pending();
    let resolve = match[1];
    let resolve$1 = uploadInfo => resolve(uploadInfo);
    send({
      TAG: "InitiateUpload",
      _0: dataUrl,
      _1: resolve$1
    });
    return match[0];
  };
}

function useUploadImage() {
  let upload = useUpload();
  return file => {
    let dataUrl = URL.createObjectURL(file);
    return ReasonPromise.map(ReasonPromise.all2(upload(dataUrl), ImageUtils.getDimensions(dataUrl)), param => {
      let dimensions = param[1];
      let result = param[0];
      URL.revokeObjectURL(dataUrl);
      if (dimensions !== undefined) {
        if (result.TAG === "Ok") {
          return {
            TAG: "Ok",
            _0: {
              info: result._0,
              dimensions: dimensions
            }
          };
        } else {
          return {
            TAG: "Error",
            _0: {
              TAG: "UploadFailed",
              _0: result._0
            }
          };
        }
      } else {
        return {
          TAG: "Error",
          _0: "UnreadableImage"
        };
      }
    });
  };
}

exports.RequestAvatarUploadV5Mutation = RequestAvatarUploadV5Mutation;
exports.initialState = initialState;
exports.useUpload = useUpload;
exports.useUploadImage = useUploadImage;
/* commitMutation Not a pure module */
